var exports = {
  "G": "MessageAvatar.module__frame___RnBMdk",
};

module.exports = exports;
